import { TaggingContainer } from '@core/model/domain/taggingTracker';
import { NotificationConfiguration } from '@core/model/framework/notificationConfiguration';
import { environment } from '@environments/environment';

export type NotificationsConfiguration = {
  webauth: NotificationConfiguration;
  caseState: NotificationConfiguration;
};

export type KernelConfiguration = {
  isInMemory: boolean;
  openBankingBaseUrl: string;
  notifications: NotificationsConfiguration;
  isTrackingEnabled: boolean;
  taggingContainers: Array<TaggingContainer>;
};

export function buildConfiguration(): KernelConfiguration {
  const isInMemory = false;
  // TODO : process not defined
  /*process.env.IN_MEMORY !== null &&
    process.env.IN_MEMORY.toLowerCase() === "true";*/

  return {
    isInMemory: isInMemory,
    openBankingBaseUrl: environment.urlOpenBanking,
    notifications: {
      webauth: {
        method: environment.webauthNotification.method,
        timeoutInSeconds: environment.webauthNotification.timeoutInSeconds,
        intervalInSeconds: environment.webauthNotification.intervalInSeconds,
      },
      caseState: {
        method: environment.caseStateNotification.method,
        timeoutInSeconds: environment.caseStateNotification.timeoutInSeconds,
        intervalInSeconds: environment.caseStateNotification.intervalInSeconds,
      },
    },
    isTrackingEnabled: environment.isTrackingEnabled,
    taggingContainers: environment.taggingContainers,
  };
}
